
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';

const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center space-x-2 bg-blue-50 text-[#3B82F6] px-4 py-2 rounded-full mb-8 animate-fade-in">
          <Sparkles className="w-4 h-4" />
          <span className="text-sm font-semibold tracking-wide uppercase">New Experience</span>
        </div>
        <h1 className="text-4xl md:text-6xl font-extrabold text-[#0F172A] mb-6 tracking-tight">
          {t('hero.title')}
        </h1>
        <p className="text-lg md:text-xl text-[#1E293B]/70 max-w-2xl mx-auto leading-relaxed">
          {t('hero.subtitle')}
        </p>
      </div>
      
      {/* Decorative blurred background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full -z-10 pointer-events-none opacity-20">
        <div className="absolute top-1/4 left-0 w-72 h-72 bg-blue-400 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-1/4 right-0 w-72 h-72 bg-indigo-400 rounded-full blur-[120px]"></div>
      </div>
    </section>
  );
};

export default Hero;
